import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

export interface ContactUSApiParameter {
    FirstName: string;
    LastName: string;
    Email: string;
    CountryId: string;
    CountryName: string;
    PhoneNumber: string;
    Company: string;
    Subject: string;
    Message: string;
}
export interface ContactUsResultModel {
    FirstName: string;
    LastName: string;
    Email: string;
    CountryId: string;
    CountryName: string;
    PhoneNumber: string;
    Company: string;
    Subject: string;
    Message: string;
}
export interface Properties {}

const autocompleteUrl = "api/v2/contactusmail";

const contactUS = "api/v2/contactusmail";

export function ContactUsForm(
    parameter: ContactUSApiParameter & HasOnSuccess<ContactUsResultModel> & HasOnComplete<ContactUsResultModel>,
) {
    const apiParameter = { ...parameter };
    delete apiParameter.onSuccess;
    delete apiParameter.onComplete;
    return post<ContactUsResultModel>(autocompleteUrl, apiParameter);
}

// export function contactusmail(parameter: ContactUSApiParameter & HasOnSuccess<ContactUsResultModel>) {
//     const ContactUsOptions = { ...parameter };
//     delete ContactUsOptions.onSuccess;
//     return post<ContactUsResultModel>(contactUS, ContactUsOptions);
// }
export function contactusmail(parameter: ContactUSApiParameter) {
    return post<ContactUSApiParameter, void>(`${contactUS}`, parameter);
}
